import Vue from "vue";
import VueRouter from "vue-router";

import Navigation from "../views/Navigation";
import Footer from "../views/Footer";
import Login from "../views/Login";

Vue.use(VueRouter);

const routeFactory = function (mainModule) {
  return {
    main: () => import(`./../views/${mainModule}`),
    top: Navigation,
    bottom: Footer,
  };
};

const routes = [
  {
    path: "/login",
    name: "login",
    components: {
      main: Login,
    },
    meta: {
      title: "ورود",
    },
  },
  {
    path: "/",
    name: "home",
    components: routeFactory("Home"),
    meta: {
      title: "داشبورد",
    },
  },
  {
    path: "/articles",
    name: "articles",
    components: routeFactory("articles/Articles"),
    meta: {
      title: "مدیریت اخبار",
    },
  },
  {
    path: "/campaigns",
    name: "campaigns",
    components: routeFactory("campaigns/Campaigns"),
    meta: {
      title: "مدیریت کمپین ها",
    },
  },
  {
    path: "/campaigns/products",
    name: "products",
    components: routeFactory("campaigns/products"),
    meta: {
      title: "محصولات",
    },
  },
  {
    path: "/campaigns/orders",
    name: "orders",
    components: routeFactory("campaigns/orders"),
    meta: {
      title: "سفارشات",
    },
  },
  {
    path: "/campaigns/:id/participation",
    name: "participation",
    components: routeFactory("campaigns/participation"),
    meta: {
      title: "لیست مشارکت در کمپین",
    },
  },
  {
    path: "/sms/report",
    name: "sms-report",
    components: routeFactory("sms_report"),
    meta: {
      title: "گزارش پیامک‌ها",
    },
  },
  {
    path: "/support-ticket",
    name: "support",
    components: routeFactory("support"),
    meta: {
      title: "مدیریت پیامها",
    },
  },
  {
    path: "/articles/categories",
    name: "articles-categories",
    components: routeFactory("articles/categories/Categories"),
    meta: {
      title: "دسته بندی ها",
    },
  },
  //#region Management
  {
    path: "/management/dashboard",
    name: "home",
    components: routeFactory("management/dashboard"),
    meta: {
      title: "داشبورد مدیریت",
    },
  },
  {
    path: "/management/users",
    name: "users",
    components: routeFactory("management/users/Users"),
    meta: {
      title: "مدیریت کاربران",
    },
  },
  {
    path: "/management/drivers",
    name: "drivers",
    components: routeFactory("management/drivers/Drivers"),
    meta: {
      title: "رانندگان",
    },
  },
  {
    path: "/management/vehicles",
    name: "vehicles",
    components: routeFactory("management/vehicles/Vehicles"),
    meta: {
      title: "ماشین آلات",
    },
  },
  {
    path: "/management/owners",
    name: "owners",
    components: routeFactory("management/owners/Owners"),
    meta: {
      title: "صاحبان بار",
    },
  },
  {
    path: "/management/owner/:id/requests",
    name: "owner-requests",
    components: routeFactory("management/owners/Requests"),
    meta: { title: "بارها" }
  },

  {
    path: "/management/carriers",
    name: "carriers",
    components: routeFactory("management/carriers/Carriers"),
    meta: {
      title: "باربری ها",
    },
  },
  {
    path: "/management/customers",
    name: "customers",
    components: routeFactory("management/customers/Customers"),
    meta: {
      title: "مشتری ها",
    },
  },
  {
    path: "/management/roles",
    name: "roles",
    components: routeFactory("management/Role/"),
    meta: {
      title: "نقش ها",
    },
  },
  {
    path: "/management/permissions",
    name: "permissions",
    components: routeFactory("management/Permission/"),
    meta: { title: "سطح دسترسی" },
  },
  {
    path: "/management/loads",
    name: "loads",
    components: routeFactory("management/loads/Loads"),
    meta: {
      title: "نوع بار ها",
    },
  },
  {
    path: '/management/driver-profile',
    name: "DriverProfile",
    components: routeFactory("management/drivers/DriverProfile"),
    meta: {
      title: "راننده",
    },
  },
  {
    path: "/management/terminals",
    name: "terminals",
    components: routeFactory("management/terminals/Terminals"),
    meta: {
      title: "ترمینال ها",
    },
  },
  {
    path: "/management/salons/:id/drivers",
    name: "salonsdrivers",
    components: routeFactory("management/salons/drivers/Index"),
    meta: {
      title: "راننده های سالن",
    },
  },
  {
    path: "/management/salons/:id/vehicles",
    name: "salonsvehicles",
    components: routeFactory("management/salons/vehicles/Index"),
    meta: {
      title: "ماشین های سالن",
    },
  },
  {
    path: "/management/salons/:id/tickets",
    name: "salonstickets",
    components: routeFactory("management/salons/tickets/Index"),
    meta: {
      title: "نوبت های سالن",
    },
  },
  {
    path: "/management/salons/:id/priorities",
    name: "salonPriorities",
    components: routeFactory("management/salons/priorities/Index"),
    meta: {
      title: "اولویت های سالن",
    },
  },
  {
    path: "/management/salons",
    name: "salons",
    components: routeFactory("management/salons/Salons"),
    meta: {
      title: "سالن ها",
    },
  },
  {
    path: "/management/notifications",
    name: "notifications",
    components: routeFactory("management/notifications/Notifications"),
    meta: {
      title: "ارسال نوتیفیکیشن",
    },
  },
  // {
  //   path: "/management/notifications/advance",
  //   name: "advancenotifications",
  //   components: routeFactory("management/notifications/AdvanceNotifications"),
  //   meta: {
  //     title: "ارسال نوتیفیکیشن",
  //   },
  // },
  {
    path: "/management/vehicle-types",
    name: "vehicletypes",
    components: routeFactory("management/vehicle-types/VehicleTypes"),
    meta: {
      title: "انواع ماشین",
    },
  },
  {
    path: "/management/native-driver",
    name: "nativedrivers",
    components: routeFactory("management/owners/Native"),
    meta: {
      title: "مدیریت رانندگان بومی",
    },
  },
  // {
  //   path: "/management/gondole",
  //   name: "vehicletypes",
  //   components: routeFactory("management/gondole/index"),
  //   meta: {
  //     title: "مدیریت گندله",
  //   },
  // },
  {
    path: "/management/requests",
    name: "requests",
    components: routeFactory("management/requests/Requests"),
    meta: {
      title: "درخواست حمل بار",
    },
  },

  {
    path: "/management/requests/:id/request-process",
    name: "requestsprocess",
    components: routeFactory("management/requests/RequestProcess"),
    meta: {
      title: "پردازش بار",
    },
  },
  {
    path: "/management/request/:id/detail",
    name: "requestdetails",
    components: routeFactory("management/request-detail/RequestDetail"),
    meta: {
      title: "ریز درخواست حمل بار",
    },
  },
  {
    path: "/requests",
    name: "requestsmanagements",
    components: routeFactory("requests_managements"),
    meta: {
      title: "کارتابل",
    },
  },
  {
    path: "/request-details",
    name: "requestdetailmanagements",
    components: routeFactory("request_detail_managements"),
    meta: {
      title: "کارتابل پشتیبان",
    },
  },
  {
    path: "/request-detail-confirmation",
    name: "requestdetailconfirmations",
    components: routeFactory(
      "request_detail_confirmation/RequestDetailConfirmation"
    ),
    meta: {
      title: "پذیرش بار",
    },
  },
  {
    path: "/gateway-transaction",
    name: "gatewaytransactions",
    components: routeFactory("gateway_transaction"),
    meta: { title: "تصویه حساب" },
  },
  {
    path: "/notifications/report",
    name: "notificationreports",
    components: routeFactory("notification_report"),
    meta: { title: "گزارش سیستم نوتیفیکیشن" },
  },
  {
    path: "/notifications/send",
    name: "notificationsends",
    components: routeFactory("notification_send"),
    meta: { title: "ارسال پیام خصوصی" },
  },

  {
    path: "/user-report",
    name: "userreports",
    components: routeFactory("user_report"),
    meta: { title: "گزارش کاربران" },
  },
  {
    path: "/static-pages",
    name: "staticpages",
    components: routeFactory("pages/static"),
    meta: {
      title: "مدیریت صفحات",
    },
  },
  {
    path: "/app-icons",
    name: "appicons",
    components: routeFactory("pages/icons"),
    meta: {
      title: "مدیریت آیکون ها",
    },
  },
  {
    path: "/management/request-job",
    name: "requestjobs",
    components: routeFactory("management/request-job/RequestJob"),
  },
  {
    path: "/manage/wallet",
    name: "fixWallet",
    components: routeFactory("manage/wallet"),
  },
  {
    path: "/manage/city",
    name: "cities",
    components: routeFactory("manage/city"),
  },
  {
    path: "/cargo",
    name: "cargoes",
    components: routeFactory("cargo/Cargo"),
  },
  {
    path: "/404",
    name: "404",
    components: {
      main: () => import(`./../views/404`),
    },
  },
  {
    path: "/403",
    name: "403",
    components: {
      main: () => import(`./../views/403`),
    },
  },

  {
    path: "/report",
    name: "report",
    components: routeFactory("report/report"),
    meta: {
      title: "چاپ",
    },
  },
  {
    path: "/report/general",
    name: "general",
    components: routeFactory("report/General"),
    meta: {
      title: "گزارشات",
    },
  },
  {
    path: "/report/wr3",
    name: "wr3",
    components: routeFactory("report/wr3"),
    meta: {
      title: "گزارش مالی به تفکیک رانندگان",
    },
  },
  {
    path: "/report/wr4",
    name: "wr4",
    components: routeFactory("report/wr4"),
    meta: {
      title: "گزارش مالی به تفکیک نوع تراکنش",
    },
  },
  {
    path: "/report/activity",
    name: "general",
    components: routeFactory("report/activity"),
    meta: {
      title: "گزارش فعالیت رانندگان"
    },
  },

  {
    path: "/reports/wr1",
    name: "wr1",
    components: routeFactory("wallet_report"),
    meta: {
      title: "گزارش مالی",
    },
  },

  {
    path: "/downloads/android",
    name: "downloads",
    components: {
      main: () => import(`./../views/Downloads`),
    },
    meta: {
      title: "دانلود",
    },
  },
  {
    path: "/wallet-report-management",
    name: "wallet-report",
    components: routeFactory("wallet_report_management"),
  },

  {
    path: "/force-change-password",
    name: "force-change-password",
    components: {
      main: () => import(`./../views/ForcePasswordChange`),
    },
    meta: { allowWhileForced: true }

  }


  //#end region Management
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
